// Re-exports from unified color system
import { useMemo } from 'react';
import { PRIMITIVE_COLORS, SEMANTIC_COLORS } from '../residentColors';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

export const LINKED_ACCOUNTS_COLORS = {
  background: SEMANTIC_COLORS.background.primary,
  cardBackground: SEMANTIC_COLORS.background.secondary,
  avatarBackground: PRIMITIVE_COLORS.white10,
  navHeaderBackground: PRIMITIVE_COLORS.resioBlue,
  navHeaderInvitationsBackground: PRIMITIVE_COLORS.resioPurple,
  innerFrameBackground: SEMANTIC_COLORS.background.primary,
  textPrimary: SEMANTIC_COLORS.text.primary,
  textSecondary: PRIMITIVE_COLORS.gray300,
  textMuted: PRIMITIVE_COLORS.gray400,
  accentPink: PRIMITIVE_COLORS.resioPink,
  accentBlue: PRIMITIVE_COLORS.resioBlue,
  accentBlueBorder: PRIMITIVE_COLORS.resioBlueBorder,
  accentPurple: PRIMITIVE_COLORS.resioPurple,
  divider: PRIMITIVE_COLORS.gray700,
  iconPrimary: SEMANTIC_COLORS.icon.primary,
  iconSecondary: SEMANTIC_COLORS.icon.secondary,
  successGreen: '#5CBC5D',
  successText: SEMANTIC_COLORS.text.inverse,
  buttonDisabled: PRIMITIVE_COLORS.gray600,
  warningOrange: PRIMITIVE_COLORS.warningOrange,
} as const;

export type LinkedAccountsColor = keyof typeof LINKED_ACCOUNTS_COLORS;

export function useLinkedAccountsColors() {
  const { semantic, components, colors } = useThemeColors();
  return useMemo(() => ({
    background: semantic.background.primary,
    cardBackground: semantic.background.secondary,
    avatarBackground: colors.activityIcon.bg,
    navHeaderBackground: components.nav.headerBlue,
    navHeaderInvitationsBackground: components.nav.headerPurple,
    innerFrameBackground: semantic.background.primary,
    textPrimary: semantic.text.primary,
    textSecondary: semantic.text.secondary,
    textMuted: semantic.text.tertiary,
    accentPink: semantic.interactive.secondary,
    accentBlue: semantic.interactive.primary,
    accentBlueBorder: semantic.border.primary,
    accentPurple: components.nav.headerPurple,
    divider: semantic.border.secondary,
    iconPrimary: semantic.icon.primary,
    iconSecondary: semantic.icon.secondary,
    successGreen: semantic.status.success,
    successText: semantic.text.inverse,
    buttonDisabled: semantic.interactive.disabled,
    warningOrange: semantic.status.warning,
  }), [semantic, components, colors]);
}
